/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Delivery_AddressInputs */

const en_orders_delivery_address = /** @type {(inputs: Orders_Delivery_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delivery Address`)
};

const es_orders_delivery_address = /** @type {(inputs: Orders_Delivery_AddressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direccion de entrega`)
};

/**
* | output |
* | --- |
* | "Delivery Address" |
*
* @param {Orders_Delivery_AddressInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_delivery_address = /** @type {((inputs?: Orders_Delivery_AddressInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Delivery_AddressInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_delivery_address(inputs)
	return es_orders_delivery_address(inputs)
});